

import { Card, Col, Divider, Drawer, Row, Tooltip, Typography } from 'antd';
import { GetAccountsIcon, GetBookingsIcon, GetBusinessIcon, GetGroupIcon, GetUserIcon } from '../../../utils/icons';
import { useAppConfig } from '../../../Contexts/AppConfigContext';
import { useTranslation } from 'react-i18next';

import dingusImage from '../../../assets/images/channels/dingus.png';
import directImage from '../../../assets/images/channels/beds2b.png';

import moment from 'moment';

import './BookingListComponent.scss'
import BookingInfo from '../../../models/BookingInfo';
import { CheckOutlined, CiOutlined, EyeOutlined, LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import BookingDetailPage from '../../../pages/Private/BookingDetailPage/BookingDetailPage';
import { useEffect, useState } from 'react';
import BookingData from '../../../models/BookingData';
import { LoadingData } from '../../common';
import HTMLReactParser from 'html-react-parser';
import { cancelBookingRewards, ImportBookingRewards } from '../../../api/repositoryEP';
import { ImportBookingRewardsData } from '../../../models/ImportBookingRewardsData';

interface BookingsListComponentProps {
    list: BookingInfo[];
    loading: boolean;
    onGetBookingData: (bookingId: string) => void;
    bookingData?: BookingData,
    setBookingData : (bookingData : BookingData) => void
    isGettingBookingData: boolean
}

const BookingsListComponent = (props: BookingsListComponentProps): JSX.Element => {
    const appConfig = useAppConfig();

    const { t } = useTranslation();

    const { loading, onGetBookingData, bookingData, setBookingData,isGettingBookingData } = props;

    const [bookingsData, setBookingsData] = useState<BookingInfo[]>([]);
    const [loadingBookingId, setLoadingBookingId] = useState<string | null>(null);





    useEffect(() => {
        setBookingsData(props.list);
    }, [props.list])
    useEffect(() => { }, [bookingsData])

    const getAccountTypeTag = (type: any) => {
        switch (type) {
            case 0: // independent
                return t("components.accounts.filter.independent");
            case 1: // events
                return t("components.accounts.filter.events");
            case 2: // independent
                return t("components.accounts.filter.agency");
            case 3: // corporate
                return t("components.accounts.filter.business");
            default:
                return t("components.accounts.filter.agency");
        }
    }

    const retryImportBooking = (record: BookingInfo) => {

        setLoadingBookingId(record.bookingId);

        const data: ImportBookingRewardsData = {
            bookingId: record.bookingId,
        };

        ImportBookingRewards(data).then((response) => {
            if (response?.type === 1 && response.data != null) {
                setBookingsData(prev =>
                    prev.map(item =>
                        item.bookingId === record.bookingId
                            ? {
                                ...item,
                                imported: true,
                                reward: response.data, // Asumiendo que response.data.reward existe
                            }
                            : item
                    )
                );
               
            }
        }).finally( ()=>setLoadingBookingId(null));
    };



    const retryCancelBooking = (record: BookingInfo) => {
        setLoadingBookingId(record.bookingId);



        cancelBookingRewards(record.bookingId).then((response) => {
            if (response?.type === 1 && response.data != null) {
                setBookingsData(prev =>
                    prev.map(item =>
                        item.bookingId === record.bookingId
                            ? {
                                ...item,
                                imported: true,
                                reward: response.data, // Asumiendo que response.data.reward existe
                            }
                            : item
                    )
                );
            }
        }).finally(() => {
            setLoadingBookingId(null);

        });
    };


    const GetStatusName = (statusName: string): string => {
        let response: string = '';
        switch (statusName) {
            case '0': // pending
                response = t("components.bookings.list.booking-status.pending");
                break;
            case '1': // pre
                response = t("components.bookings.list.booking-status.pre");
                break;
            case '2': // active
                response = t("components.bookings.list.booking-status.active");
                break;
            case '3': // cancelled
                response = t("components.bookings.list.booking-status.cancelled");
                break;
            case '4': // error
                response = t("components.bookings.list.booking-status.error");
                break;
            case '5':
                response = t('components.bookings.list.booking-status.pending_payment');
                break;
            case '6':
                response= t('components.bookings.list.booking-status.postponed');
                break;
        }

        return response;
    }

    const GetStatusEnumName = (statusName: any): string => {
        switch (statusName) {
            case 0:
                return 'pending';
            case 1:
                return 'pre';
            case 2:
                return 'active';
            case 3:
                return 'canceled';
            case 4:
                return 'error';
            case 5:
                return 'pending_payment';
            case 6:
                return 'postponed'
            default:
                return 'pending';
        }
    };


    const GetIntegrationIcon = (integrationCode: string): JSX.Element => {

        switch (integrationCode) {
            case 'Dingus':
                //Get image from asset folder
                return <Tooltip title={integrationCode} placement='right'>
                    <img src={dingusImage} alt="Dingus" className="app-image" title={integrationCode} />
                </Tooltip>
            case 'Direct':
                return <Tooltip title={integrationCode} placement='right'>
                    <img src={directImage} alt="Beds2B PRO - Direct" className="app-image" title={integrationCode} />
                </Tooltip>
        }

        return <></>

    }

    const [selected, setSelected] = useState<BookingInfo>();
    const [loadingDetailId, setLoadingDetailId] = useState<string | null>(null);

    const showBookingDetail = (item: BookingInfo) => {
        setSelected(item);
        setLoadingDetailId(item.bookingId);
        onGetBookingData(item.bookingId);
    }

    // Cuando los datos llegan (isGettingBookingData pasa a false), limpia el spinner
    useEffect(() => {
        if (!isGettingBookingData) setLoadingDetailId(null);
    }, [isGettingBookingData]);



    return (
        <div className="bookings-list">
            <Drawer
                //  className="custom-drawer"
                width="60%"

                open={selected !== undefined && bookingData !== undefined}
                onClose={() => setSelected(undefined)}
                title={t('pages.booking-detail.main-title')}
            >
                <BookingDetailPage bookingData={bookingData} setBookingData={setBookingData} isGettingBookingData={isGettingBookingData} />
            </Drawer>

            {
                loading && <LoadingData />
            }

            {
                !loading && bookingsData.map((item: BookingInfo, index: number) => {

                    const statusColors: Record<string, string> = {
                        '0': '#f0ad4e', '1': '#337ab7', '2': '#52c41a',
                        '3': '#c09494', '4': '#ff4d4f', '5': '#722ed1', '6': '#fa8c16'
                    };
                    const accentColor = statusColors[item.statusId] ?? '#ccc';
                    const statusName = GetStatusName(item.statusId);

                    const pricingBar = (
                        <div className="pricing-info">
                            <span className="integration-icon">
                                <label>{GetIntegrationIcon(item.integrationCode)}</label>
                                <small>{t("components.bookings.list.channel")}</small>
                            </span>
                            <span className="price">
                                <label>{item.pvp?.toFixed(2)} {item.currencySymbol}</label>
                                <small>{t("components.bookings.list.price")}</small>
                            </span>
                            <span className="price">
                                <label style={{ color: GetStatusEnumName(item.statusName) === 'active' ? 'red' : 'inherit' }}>
                                    {item.payed?.toFixed(2)} {item.currencySymbol}
                                </label>
                                <small>{t("components.bookings.list.payed")}</small>
                            </span>
                            {GetStatusEnumName(item.statusName) === 'active' && item.totalToPay != null && (
                                <span className="price">
                                    {/* La resta se redondea al pintarla: en coma flotante 1000.1 - 654.42 da 345.68000000000006 */}
                                    <label style={{ color: 'red' }}>{(item.totalToPay - item.payed).toFixed(2)} {item.currencySymbol}</label>
                                    <small>{t("components.bookings.list.to-be-payed")}</small>
                                </span>
                            )}
                            <span className="price">
                                <label>{item.commission?.toFixed(2)} {item.currencySymbol}</label>
                                <small>{t("components.bookings.list.commission")}</small>
                            </span>
                            <span className="price">
                                <label>
                                    {item.reward?.toFixed(2)} {item.currencySymbol}&nbsp;
                                    {appConfig.config.hasRewardsContracted && item.imported === true && (
                                        <Tooltip title={t("components.bookings.list.rewards-imported")}>
                                            <CheckOutlined style={{ color: 'green' }} />
                                        </Tooltip>
                                    )}
                                    {appConfig.config.hasRewardsContracted && (GetStatusEnumName(item.statusName) === 'active' || GetStatusEnumName(item.statusName) === 'canceled') && item.imported === false && item.rewardsUAID != null && item.rewardsUAID.trim() !== '' && (
                                        <>
                                            {item.isCancelled ? (
                                                <Tooltip title={t('components.bookings.list.retry-synchronization') || ''}>
                                                    {loadingBookingId === item.bookingId
                                                        ? <LoadingOutlined style={{ color: 'gray', cursor: 'not-allowed' }} />
                                                        : <ReloadOutlined style={{ color: 'red', cursor: 'pointer' }} onClick={() => retryCancelBooking(item)} />}
                                                </Tooltip>
                                            ) : (
                                                <Tooltip title={t('components.bookings.list.retry-synchronization') || ''}>
                                                    {loadingBookingId === item.bookingId
                                                        ? <LoadingOutlined style={{ color: 'gray', cursor: 'not-allowed' }} />
                                                        : <ReloadOutlined style={{ color: 'red', cursor: 'pointer' }} onClick={() => retryImportBooking(item)} />}
                                                </Tooltip>
                                            )}
                                        </>
                                    )}
                                </label>
                                <small>{t("components.bookings.list.rewards")}</small>
                            </span>
                        </div>
                    );

                    // ── VERSION 1 ─────────────────────────────────────────────────
                    return (
                        <div key={item.bookingId} className="booking-card-v1" style={{ borderLeftColor: accentColor }}>
                                {/* Header */}
                                <div className="v1-header" style={{ backgroundColor: `${accentColor}10` }}>
                                    <div className="v1-header__main">
                                        <span className="v1-hotel">{item.hotelName}</span>
                                        <div className="v1-locators">
                                            {item.locator && (
                                                <span className="v1-locator-chip">
                                                    <Typography.Text copyable={{ text: item.locator }}>{item.locator}</Typography.Text>
                                                </span>
                                            )}
                                            {item.ownLocator && (
                                                <span className="v1-locator-chip">
                                                    <Typography.Text copyable={{ text: item.ownLocator }}>{item.ownLocator}</Typography.Text>
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="v1-header__actions">
                                        <span className="v1-status-badge" style={{ color: accentColor, borderColor: accentColor }}>
                                            {statusName}
                                        </span>
                                        <span className="show-booking-detail" onClick={() => showBookingDetail(item)}>
                                            {loadingDetailId === item.bookingId
                                                ? <LoadingOutlined style={{ fontSize: 20 }} spin />
                                                : <EyeOutlined style={{ fontSize: 20 }} />}
                                        </span>
                                    </div>
                                </div>

                                {/* Body — CSS grid, sin Row/Col de Ant Design */}
                                <div className="v1-body">
                                    <div className="v1-col">
                                        <div className="v1-field-group">
                                            <span className="v1-label">{t("components.bookings.list.dates")}</span>
                                            <span className="v1-value">{moment(item.checkIn).format(appConfig.config.dateFormat)} → {moment(item.checkOut).format(appConfig.config.dateFormat)}</span>
                                            <span className="v1-sub">{t("components.bookings.list.created-at", [moment(item.creationDate).format(appConfig.config.dateFormat)])}</span>
                                            {item.statusId === '3' && item.cancelledDate && (
                                                <span className="v1-sub cancelled">{HTMLReactParser(t("components.bookings.list.cancel-at", [moment(item.cancelledDate).format(appConfig.config.dateFormat)]))}</span>
                                            )}
                                        </div>
                                        <div className="v1-field-group" style={{ marginTop: 18 }}>
                                            <span className="v1-label">{t("components.bookings.list.rooms")} / {t("components.bookings.list.pax")}</span>
                                            <span className="v1-value">{item.roomsNumber} {t("components.bookings.list.rooms").toLowerCase()} · {item.adultsNumber} {t("components.bookings.list.adults")}, {item.childrenNumber} {t("components.bookings.list.children")}, {item.babiesNumber} {t("components.bookings.list.babies")}</span>
                                        </div>
                                    </div>
                                    <div className="v1-col">
                                        <div className="v1-field-group">
                                            <span className="v1-label">{t("components.bookings.list.owner")}</span>
                                            <span className="v1-value">{item.ownerName}</span>
                                            <span className="v1-sub"><a href={`mailto:${item.ownerEmail}`}>{item.ownerEmail}</a></span>
                                            {item.ownerPhone && <span className="v1-sub">{item.ownerPhone}</span>}
                                        </div>
                                    </div>
                                    <div className="v1-col">
                                        <div className="v1-field-group">
                                            <span className="v1-label">{t("components.bookings.list.account")}</span>
                                            <span className="v1-value">{item.accountInfo.bussinessName}</span>
                                            <span className="v1-sub">{getAccountTypeTag(item.accountInfo.accountType)}</span>
                                        </div>
                                        <Divider style={{ margin: '6px 0' }} />
                                        <div className="v1-account-sub">
                                            <div className="v1-field-group">
                                                <span className="v1-label">{t("components.bookings.list.account-admin")}</span>
                                                <span className="v1-value">{item.superAdminName}</span>
                                                <span className="v1-sub"><a href={`mailto:${item.superAdminEmail}`}>{item.superAdminEmail}</a></span>
                                            </div>
                                            <div className="v1-field-group">
                                                <span className="v1-label">{t("components.bookings.list.user")}</span>
                                                <span className="v1-value">{item.creationUser}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Pricing */}
                                <div className="v1-pricing">
                                    {pricingBar}
                                </div>
                            </div>
                        );
                })
            }
        </div>
    )
}

export default BookingsListComponent;